import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="w-full h-screen overflow-y-scroll">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-8 pb-20">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Terms & Conditions
          </h1>
          <p className="text-gray-500 mb-8">
            <b>Last updated on: December 2025</b>
          </p>

          <div className="bg-white rounded-lg border border-gray-200 shadow-md p-8 mb-6">
            <p className="text-gray-700 leading-relaxed mb-4">
              These Terms and Conditions, along with{" "}
              <a href="/privacy-policy" className="text-[#BE3144] underline">
                privacy policy
              </a>{" "}
              or other terms
              ("Terms") constitute a binding agreement by and between{" "}
              <strong className="text-gray-900">LEVIT8 LABS PRIVATE LIMITED</strong>{" "}
              (a private limited company), ("Website Owner" or "we" or "us" or "our")
              and you ("you" or "your") and relate to your use of our website and
              services.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              These Terms apply to all services provided under the{" "}
              <strong className="text-gray-900">TryOn AI</strong> and{" "}
              <strong className="text-gray-900">TryOn Labs</strong> brands, which
              are owned and operated by LEVIT8 LABS PRIVATE LIMITED. Our services
              include virtual try-on, model swap, cataloging, model generation,
              garment generation, and image editing and enhancement services designed
              for fashion brands, D2C brands, and individuals.
            </p>
            <p className="text-gray-700 leading-relaxed">
              By using our website and availing the Services, you agree that you
              have read and accepted these Terms (including the Privacy Policy). We
              reserve the right to modify these Terms at any time and without
              assigning any reason. It is your responsibility to periodically
              review these Terms to stay informed of updates.
            </p>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 shadow-md p-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Terms of Use
            </h2>
            <p className="text-gray-600 text-sm mb-6">
              The use of this website or availing of our Services is subject to the
              following terms of use:
            </p>
            <ul className="list-disc ml-6 space-y-3 text-gray-700 text-sm leading-relaxed">
              <li>
                To access and use the Services, you agree to provide true, accurate
                and complete information to us during and after registration, and
                you shall be responsible for all acts done through the use of your
                registered account.
              </li>
              <li>
                Neither we nor any third parties provide any warranty or guarantee
                as to the accuracy, timeliness, performance, completeness or
                suitability of the information and materials offered on this website
                or through the Services, for any specific purpose. You acknowledge
                that such information and materials may contain inaccuracies or
                errors and we expressly exclude liability for any such inaccuracies
                or errors to the fullest extent permitted by law.
              </li>
              <li>
                Your use of our Services and the website is solely at your own risk
                and discretion. You are required to independently assess and ensure
                that the Services meet your requirements.
              </li>
              <li>
                The contents of the Website and the Services, including but not
                limited to AI-generated images, models, and visual content, are
                proprietary to Us and you will not have any authority to claim any
                intellectual property rights, title, or interest in its contents
                beyond the rights granted to you for the specific deliverables you
                have purchased.
              </li>
              <li>
                You acknowledge that unauthorized use of the Website or the Services
                may lead to action against you as per these Terms or applicable
                laws.
              </li>
              <li>
                You agree to pay us the charges associated with availing the
                Services. Services are provided on a credit-based or subscription
                basis, and you agree to maintain sufficient credits or an active
                subscription to use the Services.
              </li>
              <li>
                You agree not to use the website and/or Services for any purpose
                that is unlawful, illegal or forbidden by these Terms, or Indian or
                local laws that might apply to you.
              </li>
              <li>
                You agree and acknowledge that the website and the Services may
                contain links to other third party websites. On accessing these
                links, you will be governed by the terms of use, privacy policy and
                such other policies of such third party websites.
              </li>
              <li>
                You understand that upon initiating a transaction for availing the
                Services you are entering into a legally binding and enforceable
                contract with us for the Services.
              </li>
              <li>
                You shall be entitled to claim a refund of the payment made by you
                in case we are not able to provide the Service. The timelines for
                such return and refund will be according to the specific Service you
                have availed or within the time period provided in our Cancellation
                & Refund Policy. In case you do not raise a refund claim within the
                stipulated time, this would make you ineligible for a refund.
              </li>
              <li>
                For credit-based services, credits are non-transferable and
                non-refundable once purchased, except as provided in our Cancellation
                & Refund Policy. Credits may have an expiration date as specified at
                the time of purchase.
              </li>
              <li>
                For subscription-based services, you agree to pay the subscription
                fees as specified. Subscriptions will automatically renew unless
                cancelled before the renewal date. Cancellation of subscriptions
                will take effect at the end of the current billing period.
              </li>
              <li>
                You agree to use the Services only for lawful purposes and in
                accordance with these Terms. You shall not use the Services to
                generate content that is illegal, harmful, defamatory, or violates
                any third-party rights.
              </li>
              <li>
                Notwithstanding anything contained in these Terms, the parties
                shall not be liable for any failure to perform an obligation under
                these Terms if performance is prevented or delayed by a force
                majeure event.
              </li>
              <li>
                These Terms and any dispute or claim relating to it, or its
                enforceability, shall be governed by and construed in accordance
                with the laws of India.
              </li>
              <li>
                All disputes arising out of or in connection with these Terms shall
                be subject to the exclusive jurisdiction of the courts in Bengaluru,
                Karnataka.
              </li>
              <li>
                All concerns or communications relating to these Terms must be
                communicated to us using the contact information provided on this
                website.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
